<template>
    <div class="row">
        <div class="col-xl-12">
            <!-- begin: Single Modal -->
            <router-view />
            <!-- end: Single Modal -->

            <div v-show="$route.path == '/QCReport/QCGroupByOfficer'"
                 class="kt-portlet kt-portlet--mobile">
                <div class="kt-portlet__head kt-portlet__head--lg">
                    <div class="kt-portlet__head-label">
                        <span class="kt-portlet__head-icon">
                            <i class="fa fa-store"></i>
                        </span>
                        <h3 class="kt-portlet__head-title">
                            {{ this.$route.meta.breadcrumb }}
                        </h3>
                    </div>
                </div>
                <div class="kt-portlet__body">
                    <!-- begin: Search Form -->
                    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
                        <div class="row">
                            <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                                <div class="form-group">
                                    <label>เขตการขาย:</label>
                                    <!-- <select2
                                      :css-style="'width: 100%;'"
                                      :css-class="'form-control m-select2'"
                                      :id="'reDepartments'"
                                      :name="'reDepartments'"
                                      :select2-options="reDepartmentsOptions"
                                      multiple
                                      v-model="reDepartments"
                                    ></select2> -->
                                    <treeselect v-model="reDepartments"
                                                :multiple="true"
                                                :options="reDepartmentsOptions"
                                                :clear-on-select="true"
                                                placeholder="กรุณาเลือก" />
                                </div>
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                                <div class="form-group">
                                    <label>ชื่อเจ้าหน้าที่:</label>
                                    <!-- <select2
                                      :css-style="'width: 100%;'"
                                      :css-class="'form-control m-select2'"
                                      :id="'reUserIds'"
                                      :name="'reUserIds'"
                                      :select2-options="reUserIdsOptions"
                                      multiple
                                      v-model="reUserIds"
                                    ></select2> -->
                                    <!-- <treeselect
                                      v-model="reUserIds"
                                      :multiple="true"
                                      :load-options="LoadreUserIdsOptions"
                                      :async="true"
                                      v-on:select="ClearAfterselect"
                                      v-on:open="onClick"
                                      searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                                      placeholder="กรุณาเลือก"
                                      id="test"
                                    /> -->
                                    <treeselect v-model="reUserIds"
                                                :multiple="true"
                                                :async="true"
                                                :cacheOptions="false"
                                                :load-options="LoadreUserIdsOptions"
                                                v-on:open="reLoadreUserIdsOptions"
                                                v-on:select="ClearAfterselect"
                                                searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                                                placeholder="กรุณาเลือก"
                                                ref="reUserIds" />
                                </div>
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                                <div class="form-group ">
                                    <label class="label">วันที่เริ่มต้น:</label>
                                    <div class="input-group date">
                                        <input readonly
                                               type="text"
                                               class="form-control"
                                               placeholder="(วว/ดด/ปปปป)"
                                               id="reStartDate"
                                               name="reStartDate"
                                               ref="reStartDate" />
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                <i class="la la-calendar-check-o"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                                <div class="form-group">
                                    <label class="label">วันที่สิ้นสุด:</label>
                                    <div class="input-group date">
                                        <input readonly
                                               type="text"
                                               class="form-control"
                                               placeholder="(วว/ดด/ปปปป)"
                                               id="reEndDate"
                                               name="reEndDate"
                                               ref="reEndDate" />
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                <i class="la la-calendar-check-o"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                                <div class="form-group">
                                    <label>สถานะประเภทร้านค้า:</label>
                                    <treeselect v-model="shmShopGroupId"
                                                :multiple="true"
                                                :options="shmShopGroupIdOptions"
                                                :clear-on-select="true"
                                                placeholder="กรุณาเลือก" />
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-xl-6">
                                <button type="submit" class="btn btn-primary">
                                    Generate Report
                                </button>
                                <button type="reset"
                                        class="btn btn-secondary"
                                        @click="formReset">
                                    ล้างค่าทั้งหมด
                                </button>
                            </div>
                            <div class="col-xl-6 text-right">
                                <button class="btn btn-outline-primary"
                                        @click="exportQIGroupByOfficer">
                                    <span>
                                        <i class="fas fa-file-export"></i><span>Export Excel</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </form>
                    <!-- end: Search Form -->
                    <!--begin: Table -->
                    <div class="row">
                        <div class="col-lg-12 table-responsive">
                            <table class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                                   id="QIGroupByOfficerTable"
                                   style="width:100%">
                                <thead>
                                    <tr>
                                        <th class="all text-right" colspan="6">
                                            ข้อมูล ณ วันที่ {{ reAaDateReq }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="all text-center">ลำดับ</th>
                                        <th class="all text-center">ชื่อเจ้าหน้าที่</th>
                                        <th class="all text-center">ตัวแทนจำหน่าย</th>
                                        <th class="all text-center">เขตขาย</th>
                                        <th class="all text-center">จำนวนร้านค้าที่สำรวจ</th>
                                        <th class="all text-center">จำนวนร้านค้าที่ไม่ได้สำรวจ</th>
                                    </tr>
                                </thead>
                                <!-- <tfoot v-if="isShowFooter">
                                  <tr style="background-color:#edeff2">
                                    <th class="all text-center" colspan="4">จำนวนรวม</th>
                                    <th class="all text-center">
                                      {{ reCheckInTotal | currency("", 0) }}
                                    </th>
                                    <th class="all text-center">
                                      {{ reNonCheckInTotal | currency("", 0) }}
                                    </th>
                                  </tr>
                                </tfoot> -->
                            </table>
                        </div>
                    </div>
                    <!--end: Table -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import router from "../../router";
    import select2 from "../../Shared/Select2";
    import axios from "axios";
    // import the component
    import Treeselect from "@riophae/vue-treeselect";
    // import the styles
    import "@riophae/vue-treeselect/dist/vue-treeselect.css";
    import DatatableWarning from "../../Shared/DatatableWarning";

    require("datatables.net-autofill-bs4");
    require("datatables.net-bs4");
    require("datatables.net-buttons-bs4");
    require("datatables.net-colreorder-bs4");
    require("datatables.net-fixedcolumns-bs4");
    require("datatables.net-fixedheader-bs4");
    require("datatables.net-keytable-bs4");
    require("datatables.net-responsive-bs4");
    require("datatables.net-rowgroup-bs4");
    require("datatables.net-rowreorder-bs4");
    require("datatables.net-scroller-bs4");
    require("datatables.net-select-bs4");
    require("sweetalert2");

    const simulateAsyncOperation = fn => {
        setTimeout(fn, 2000)
    }

    export default {
        components: {
            select2,
            Treeselect,
        },
        data: function () {
            var self = this;
            const today = moment();
            //const startOfMonth = moment().subtract(1, 'year');
            const startOfMonth = moment().startOf('month'); // ต้นเดือน

            return {
                reAaDateReq: null,
                reDepartments: [],
                reUserIds: [],
                //isShowFooter: false,
                // reCheckInTotal: 0,
                // reNonCheckInTotal: 0,
                reStartDate: startOfMonth,
                reEndDate: today,
                reDepartmentsOptions: [],
                reIsInitial: true,
                shmShopGroupId: ["1"],
                shmShopGroupIdOptions: [],
                // reDepartmentsOptions: {
                //   minimumResultsForSearch: -1,
                //   placeholder: "กรุณาเลือกเขตการขาย",
                //   allowClear: true,
                //   ajax: {
                //     url: "/Api/Agents/Select2SearchDepartment",
                //     data: function(params) {
                //       var query = {
                //         search: params.term,
                //         page: params.page || 1,
                //       };
                //       return query;
                //     },
                //     processResults: function(data, params) {
                //       return {
                //         results: data.results,
                //         pagination: {
                //           more: data.more,
                //         },
                //       };
                //     },
                //     transport: function(params, success, failure) {
                //       params.beforeSend = function(request) {
                //         request.setRequestHeader(
                //           "Authorization",
                //           "Bearer " + self.$root.user.access_token
                //         );
                //       };
                //       var $request = $.ajax(params);
                //       $request.then(success);
                //       $request.fail(failure);
                //       return $request;
                //     },
                //   },
                // },
                reUserIdsOptions: [],
                // reUserIdsOptions: {
                //   placeholder: "กรุณาเลือกเจ้าหน้าที่",
                //   allowClear: false,
                //   ajax: {
                //     delay: 300,
                //     url: "/Api/Users/Select2User",
                //     data: function(params) {
                //       var query = {
                //         search: params.term,
                //         page: params.page || 1,
                //       };
                //       return query;
                //     },
                //     processResults: function(data, params) {
                //       return {
                //         results: data.results,
                //         pagination: {
                //           more: data.more,
                //         },
                //       };
                //     },
                //     transport: function(params, success, failure) {
                //       params.beforeSend = function(request) {
                //         request.setRequestHeader(
                //           "Authorization",
                //           "Bearer " + self.$root.user.access_token
                //         );
                //       };
                //       var $request = $.ajax(params);
                //       $request.then(success);
                //       $request.fail(failure);
                //       return $request;
                //     },
                //   },
                // },
            };
        },
        computed: {},
        methods: {
            formReset: function (e) {
                let self = this;
                self.reDepartments = [];
                self.reUserIds = [];
                self.shmShopGroupId = ["1"];


                // สร้างค่าเริ่มต้นย้อนหลัง 1 ปีจากวันนี้
                const today = moment();
                //const startOfMonth = moment().subtract(1, 'year'); // 🔹 ย้อน 1 ปี
                const startOfMonth = moment().startOf('month'); // ต้นปี

                self.reStartDate = startOfMonth;
                self.reEndDate = today;
                setTimeout(() => {
                    $(self.$refs.reStartDate)
                        .datepicker("setDate", startOfMonth.toDate());

                    $(self.$refs.reEndDate)
                        .datepicker("setDate", today.toDate());
                }, 50);

                $("#reDepartments")
                    .val("")
                    .trigger("change");

                $("#reUserIds")
                    .val("")
                    .trigger("change");

                //$("#reStartDate")
                //    .val("")
                //    .trigger("change");

                //$("#reEndDate")
                //    .val("")
                //    .trigger("change");

                $("#shmShopGroupId")
                    .val("")
                    .trigger("change");

                this.formSubmit(e);
            },
            formSubmit: function (e) {
                let self = this;

                e.preventDefault();
                var table = $("#QIGroupByOfficerTable").DataTable();
                table.draw();
            },
            exportQIGroupByOfficer: function (e) {
                e.preventDefault();
                let self = this;

                if (
                    !$(this.$refs.form)
                        .validate()
                        .form()
                ) {
                    return false;
                }

                KTApp.blockPage({
                    opacity: 0.05,
                    message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
                });

                axios({
                    method: "post",
                    url: "/Api/Report/ExportQIGroupByOfficer",
                    responseType: "arraybuffer",
                    data: {
                        Departments: self.reDepartments,
                        UserIds: self.reUserIds,
                        StartDate:
                            self.reStartDate != null
                                ? self.reStartDate.format("DD/MM/YYYY")
                                : self.reStartDate,
                        EndDate:
                            self.reEndDate != null
                                ? self.reEndDate.format("DD/MM/YYYY")
                                : self.reEndDate,
                        IsInitial: self.reIsInitial,
                        ShopGroupIds: self.shmShopGroupId,
                    },
                })
                    .then(function (response) {
                        if (response.status == "200") {
                            let filename = "";
                            let contentType = response.headers["content-type"];
                            let disposition = response.headers["content-disposition"];

                            //===Get Filename===
                            if (disposition && disposition.indexOf("attachment") !== -1) {
                                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                                var matches = filenameRegex.exec(disposition);
                                if (matches != null && matches[1]) {
                                    filename = matches[1].replace(/['"]/g, "");
                                }
                            }

                            //Save file
                            let blob = new Blob([response.data], { type: contentType });
                            let link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            link.download = filename;
                            link.click();
                        } else if (response.status == "204") {
                            Swal.fire(
                                "ไม่พบข้อมูล",
                                "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
                                "warning"
                            );
                        }
                    })
                    .catch(function (error) {
                        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                    })
                    .then(function () {
                        //self.formReset();
                        KTApp.unblockPage();
                    });
            },
            LoadreDepartmentsOptions: function (e) {
                var self = this;
                // axios
                //   .get("/Api/Agents/Select2SearchDepartment", {
                //     params: {
                //       page: 1,
                //       all: true,
                //     },
                //   })
                //   .then(function(response) {
                //     if (response.status == 200) {
                //       var data = response.data.results;
                //       data.forEach((element) => {
                //         self.reDepartmentsOptions.push({
                //           id: element.id,
                //           label: element.text,
                //         });
                //       });
                //     }
                //   })
                //   .catch(function(error) {});
                axios
                    .get("/Api/MasterSalesArea/FindOptions", {
                        params: {
                            page: 1,
                            all: true,
                            companyType: "COMPANY_PROFILE_TYPE_QI",
                        },
                    })
                    .then(function (response) {
                        if (response.status == 200) {
                            var data = response.data.results;
                            data.forEach((element) => {
                                self.reDepartmentsOptions.push({
                                    id: element.id,
                                    label: element.text,
                                });
                            });
                        }
                    })
                    .catch(function (error) { });
            },
            LoadreUserIdsOptions({ action, searchQuery, callback }) {
                var self = this;

                if (action == "ASYNC_SEARCH") {
                    simulateAsyncOperation(() => {
                        axios({
                            method: "post",
                            url: "/Api/Users/Select2QIGroupByOfficer",
                            data: {
                                page: 1,
                                search: searchQuery,
                                SalesAreaIds: self.reDepartments,
                                AgentCodes: [],
                                all: true,
                            },
                        })
                            .then(function (response) {
                                if (response.status == 200) {
                                    var data = response.data.results;
                                    self.reUserIdsOptions = [];
                                    data.forEach((element) => {
                                        self.reUserIdsOptions.push({
                                            id: element.id,
                                            label: element.text,
                                        });
                                    });
                                    callback(null, self.reUserIdsOptions)
                                }
                            })
                            .catch(function (error) { });
                    })
                }
            },
            reLoadreUserIdsOptions: function () {
                this.$refs.reUserIds.trigger.searchQuery = null;
            },
            ClearAfterselect: function () {
                $(`[class="vue-treeselect__input"]`).val("");
            },
            LoadShopGroupIdOptions: function (e) {
                var self = this;
                axios
                    .get("/Api/ShopType/Select2SearchShopGroup", {
                        params: {
                            page: 1,
                            all: true,
                        },
                    })
                    .then(function (response) {
                        if (response.status == 200) {
                            var data = response.data.results;
                            data.forEach((element) => {
                                self.shmShopGroupIdOptions.push({
                                    id: element.id,
                                    label: element.text,
                                });
                            });
                        }
                    })
                    .catch(function (error) { });
            },
        },
        async mounted() {
            let self = this;

            self.LoadreDepartmentsOptions();
            // self.LoadreUserIdsOptions();
            self.LoadShopGroupIdOptions();
            //self.shmShopGroupId = [1];
            var arrows;
            if (KTUtil.isRTL()) {
                arrows = {
                    leftArrow: '<i class="la la-angle-right"></i>',
                    rightArrow: '<i class="la la-angle-left"></i>',
                };
            } else {
                arrows = {
                    leftArrow: '<i class="la la-angle-left"></i>',
                    rightArrow: '<i class="la la-angle-right"></i>',
                };
            }

            self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

            //====== กำหนดค่าเริ่มต้น วันที่ส่งซ่อม =======
            // สร้างค่าเริ่มต้นย้อนหลัง 1 ปีจากวันนี้
            const today = moment();
            //const startOfMonth = moment().subtract(1, 'year'); // 🔹 ย้อน 1 ปี
            const startOfMonth = moment().startOf('month'); // ต้นปี

            // กำหนดค่า moment ให้ตัวแปรใน Vue (ถ้ามี)
            self.reStartDate = startOfMonth;
            self.reEndDate = today;


            //=========== Start Date ===============
            $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                //minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows,
            });
            $(self.$refs.reStartDate)
                .datepicker("update", startOfMonth.format("DD/MM/YYYY"))
                .on("changeDate", function (e) {
                    if (e.dates && e.dates.length) {
                        self.reStartDate = moment(e.date);
                    } else {
                        self.reStartDate = null;
                    }
                });
            ////self.reStartDate = moment().set("date",1);
            //$(self.$refs.reStartDate)
            //  .datepicker(
            //    "update",
            //    !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
            //  )
            //  .on("changeDate", function(e) {
            //    self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
            //  });

            //============= End Date ==============
            $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows,
            });
            //self.reEndDate = moment().endOf('month');
            $(self.$refs.reEndDate)
                .datepicker(
                    "update",
                    !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
                )
                .on("changeDate", function (e) {
                    self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
                });

            //=================================================

            $.fn.dataTable.ext.errMode = 'none';
            var table = $("#QIGroupByOfficerTable");
            //begin first table
            table
                .DataTable({
                    autoWidth: true,
                    scrollY: "100%",
                    scrollX: true,
                    responsive: true,
                    processing: true,
                    serverSide: true,
                    searchDelay: 500,
                    ajax: {
                        url: "/Api/Report/QIGroupByOfficer",
                        type: "post",
                        dataType: "json",
                        contentType: "application/json",
                        beforeSend: function (request) {
                            request.setRequestHeader(
                                "Authorization",
                                "Bearer " + self.$root.user.access_token
                            );
                        },
                        data: function (d) {
                            let jsonSearch = {
                                Departments: self.reDepartments,
                                UserIds: self.reUserIds,
                                StartDate:
                                    self.reStartDate != null
                                        ? self.reStartDate.format("DD/MM/YYYY")
                                        : self.reStartDate,
                                EndDate:
                                    self.reEndDate != null
                                        ? self.reEndDate.format("DD/MM/YYYY")
                                        : self.reEndDate,
                                IsInitial: self.reIsInitial,
                                ShopGroupIds: self.shmShopGroupId,
                            };
                            return JSON.stringify($.extend(d, jsonSearch));
                        },
                    },
                    // DOM Layout settings
                    dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

                    lengthMenu: [30, 50, 100],

                    pageLength: 30,

                    language: {
                        lengthMenu: "Display _MENU_",
                    },
                    // Order settings
                    order: [[1, "asc"]],
                    columns: [
                        {
                            data: "userFullName",
                            className: "text-center",
                            render: function (data, type, full, meta) {
                                var t = table.DataTable();
                                var page = t.page.info().start + 1;
                                return page + meta.row;
                            },
                        },
                        { data: "userFullName", className: "text-center" },
                        { data: "agentName", className: "text-center" },
                        { data: "department", className: "text-center" },
                        {
                            data: "checkInCount",
                            className: "text-center",
                            render: function (value) {
                                return self.$options.filters.currency(value, "", 0);
                            },
                        },
                        {
                            data: "nonCheckInCount",
                            className: "text-center",
                            render: function (value) {
                                return self.$options.filters.currency(value, "", 0);
                            },
                        },
                    ],
                    drawCallback: function (settings) {
                        self.reIsInitial = false;
                        self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                        var allPage = table.DataTable().page.info().pages;
                        var currentPage = table.DataTable().page.info().page + 1;

                        // self.isShowFooter = false;
                        // self.reCheckInTotal = 0;
                        // self.reNonCheckInTotal = 0;

                        // if (allPage == currentPage) {
                        //   self.isShowFooter = true;
                        //   self.reCheckInTotal = settings.json.data[0].checkInTotal;
                        //   self.reNonCheckInTotal = settings.json.data[0].nonCheckInTotal;
                        // }
                    },
                })
                .on("error.dt", function (e, settings, techNote, message) {
                    DatatableWarning.alert(techNote);
                })
                .on("draw.dt", function () {
                    // var t = table.DataTable();
                    // var page = t.page.info().start + 1;
                    // t.column(0, {}).nodes().each( function (cell, i) {
                    //     cell.innerHTML = i+page;
                    // } );
                });

            $(this.$refs.form).validate().settings.ignore = ":hidden";
        },
    };
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/QIGroupByOfficer.vue